import { render, staticRenderFns } from "./ChainTableRow.vue?vue&type=template&id=310969e3&scoped=true"
import script from "./ChainTableRow.vue?vue&type=script&lang=js"
export * from "./ChainTableRow.vue?vue&type=script&lang=js"
import style0 from "./ChainTableRow.vue?vue&type=style&index=0&id=310969e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310969e3",
  null
  
)

export default component.exports